import React from 'react';
import {Form, Tooltip, OverlayTrigger, Button} from 'react-bootstrap';
import {useField, useFormikContext} from 'formik';
import {unset} from 'lodash';
import {StyledMaskedInput, StyledLabel, StyledRequiredLabel} from '@styled';

const Input = ({
  mask,
  label,
  placeholder,
  description,
  required,
  id,
  field,
  meta,
  disabled,
  onChange,
  width,
  tooltip = null,
  textAlignment,
}) => {
  const isInvalid = meta.error ? true : false;

  const renderTooltip = (props) => (
    <Tooltip id={`button-tooltip-${tooltip.id}`} {...props}>
      {tooltip.text}
    </Tooltip>
  );

  const renderTooltipIcon = () => {
    return tooltip ? (
      <OverlayTrigger
        placement={tooltip.position || 'auto'}
        delay={{show: 250, hide: 400}}
        overlay={renderTooltip}
      >
        <Button
          size="sm"
          variant="secondary"
          style={{
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            color: '#000000',
            opacity: 0.5,
          }}
        >
          {tooltip.icon ? (
            tooltip.icon
          ) : (
            <i className="fa fa-question-circle" />
          )}
        </Button>
      </OverlayTrigger>
    ) : null;
  };

  return (
    <Form.Group controlId={id}>
      {label && <StyledLabel>{label}</StyledLabel>}
      {label && required && <StyledRequiredLabel>*</StyledRequiredLabel>}
      {renderTooltipIcon()}
      <StyledMaskedInput
        required={required || false}
        placeholder={placeholder}
        mask={mask}
        disabled={disabled}
        width={width}
        value={meta.value}
        {...field}
        onChange={onChange}
        className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
        style={{textAlign: textAlignment || undefined}}
      />
      {description && (
        <Form.Text className="text-muted">{description}</Form.Text>
      )}

      {isInvalid && (
        <Form.Control.Feedback type="invalid">
          {meta.error || ''}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

const InputController = (props) => {
  const [field, meta, helpers] = useField(props);
  const {errors, setErrors} = useFormikContext();

  const onChange = (e) => {
    if (props.onChange) {
      props.onChange(e);
    } else {
      field.onChange(e);
    }
    const tmpErrors = errors;
    unset(tmpErrors, field.name);
    setErrors(tmpErrors);
  };
  return () => Input({...props, field, meta, helpers, onChange});
};

const MaskedInputField = (props) => InputController(props)();
export default MaskedInputField;
